import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref } from 'vue';
import { useThemeStore } from '@/stores/theme';
import BackgroundRechargeOne from '@/themes/themeOne/backgroundRecharge/backgroundRecharge.vue';
import BackgroundRechargeTwo from '@/themes/themeTwo/backgroundRecharge/backgroundRecharge.vue';
import BackgroundRechargeThree from '@/themes/themeThree/backgroundRecharge/backgroundRecharge.vue';
import { backendRechargeClaim } from '@/api/home';
import { useUserStore } from '@/stores/user';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'backendRecharge',
  emits: ['getDepositClaim', 'resetShowTreasurePopup'],
  setup(__props, { expose: __expose, emit: __emit }) {

const themeStore = useThemeStore()
const userStore = useUserStore()
const backgroundRechargeRef = ref()
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const emits = __emit

const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
const showError = (msg: string) => {
    toastContent.value = msg
    isSuccess.value = false
    statusRef.value.open()
}
const showSuccess = (msg: string) => {
    toastContent.value = msg
    isSuccess.value = true
    statusRef.value.open()
}
const openPopup = () => {
    backgroundRechargeRef.value.open()
}
const getClaim = async () => {
    loadingRef.value.open()
    let payload = {
        batchRechargeId: userStore.pendingBackendRecharge?.id
    }
    const data = await backendRechargeClaim(payload)
    loadingRef.value.close()
    if (data.code === 200) {
        showSuccess(data.msg)
        backgroundRechargeRef.value.directClose()
    } else {
        showError(data.msg)
    }
    setTimeout(() => {
        userStore.getInfo()
    }, 1500)
}

__expose({ openPopup })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(BackgroundRechargeOne, {
            ref_key: "backgroundRechargeRef",
            ref: backgroundRechargeRef,
            onResetShowTreasurePopup: resetShowTreasurePopup,
            onGetClaim: getClaim
          }, null, 512)
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BackgroundRechargeTwo, {
            ref_key: "backgroundRechargeRef",
            ref: backgroundRechargeRef,
            onGetClaim: getClaim,
            onGetDepositClaim: _cache[0] || (_cache[0] = () => emits('getDepositClaim')),
            onResetShowTreasurePopup: resetShowTreasurePopup
          }, null, 512)
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(BackgroundRechargeThree, {
            ref_key: "backgroundRechargeRef",
            ref: backgroundRechargeRef,
            onGetClaim: getClaim,
            onGetDepositClaim: _cache[1] || (_cache[1] = () => emits('getDepositClaim')),
            onResetShowTreasurePopup: resetShowTreasurePopup
          }, null, 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})